import { render, staticRenderFns } from "./BookTest.vue?vue&type=template&id=7913db84&"
import script from "./BookTest.vue?vue&type=script&lang=ts&"
export * from "./BookTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports